import { AmountTypeEnum } from "api";
import dayjs, { Dayjs } from "dayjs";
import * as yup from "yup";

import {
  PAYER_NAME_TOKEN,
  ORDER_NUMBER_TOKEN,
} from "shared/functions/ibanQrHelpers";

export type FormValues = {
  amount?: number;
  paymentPurpose: string;
  amountType: AmountTypeEnum;
  showNotes?: boolean;
  notes?: string;
  showClientNotes?: boolean;
  clientNotes?: string;
  showInvoiceExpiration?: boolean;
  expirationDateTimeLocal?: Dayjs | null;
  requestPayerFullName?: boolean;
  requestOrderNumber?: boolean;
};

export const validationSchema = yup.object({
  amount: yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .when("amountType", {
      is: AmountTypeEnum.MerchantDefined,
      then: (schema) =>
        schema.moreThan(0, "Вкажіть 'Суму'").required("Вкажіть 'Суму'"),
      otherwise: (schema) => schema,
    }),
  amountType: yup.mixed<AmountTypeEnum>().required("Вкажіть 'Тип суми'"),
  paymentPurpose: yup
    .string()
    .required("Вкажіть 'Призначення платежу'")
    .test(
      "payer-name-required",
      "Вимкніть налаштування «Запитувати Ім'я та прізвище» або додайте текст {{ім'я та прізвище клієнта}} до призначення платежу",
      function (value) {
        if (!this.parent.requestPayerFullName) return true;
        return value.includes(PAYER_NAME_TOKEN);
      },
    )
    .test(
      "payer-name-unexpected",
      "Увімкніть налаштування «Запитувати Ім'я та прізвище» або приберіть текст {{ім'я та прізвище клієнта}} з призначення платежу",
      function (value) {
        if (this.parent.requestPayerFullName) return true;
        return !value.includes(PAYER_NAME_TOKEN);
      },
    )
    .test(
      "order-number-required",
      "Вимкніть налаштування «Запитувати Номер замовлення» або додайте текст {{номер замовлення}} до призначення платежу",
      function (value) {
        if (!this.parent.requestOrderNumber) return true;
        return value.includes(ORDER_NUMBER_TOKEN);
      },
    )
    .test(
      "order-number-unexpected",
      "Увімкніть налаштування «Запитувати Номер замовлення» або приберіть текст {{номер замовлення}} з призначення платежу",
      function (value) {
        if (this.parent.requestOrderNumber) return true;
        return !value.includes(ORDER_NUMBER_TOKEN);
      },
    ),
  expirationDateTimeLocal: yup
    .mixed<Dayjs>()
    .nullable()
    .when("showInvoiceExpiration", {
      is: true,
      then: (schema) =>
        schema.test(
          "is-future",
          "Дата має бути в майбутньому",
          (value) => !value || dayjs(value).isAfter(),
        ),
    }),
});
